type PendingEntityType = 'service' | 'brief';

export interface PendingExampleWork {
    id: string | number;
    type: 'video' | 'image';
    thumbnailUrl: string;
    videoUrl?: string;
    images?: string[];
    title: string;
    uploadState: 'uploading';
}

const PENDING_EXAMPLE_WORKS_CHANGED_EVENT = 'pending_example_works_changed';
const pendingExampleWorksStore = new Map<string, PendingExampleWork[]>();

const buildKey = (entityType: PendingEntityType, entityId: string | number) => `${entityType}:${entityId}`;

const emitChange = (entityType: PendingEntityType, entityId: string | number) => {
    window.dispatchEvent(new CustomEvent(PENDING_EXAMPLE_WORKS_CHANGED_EVENT, {
        detail: {
            entityType,
            entityId: String(entityId)
        }
    }));
};

export const pendingExampleWorksService = {
    eventName: PENDING_EXAMPLE_WORKS_CHANGED_EVENT,

    getPendingExampleWorks(entityType: PendingEntityType, entityId?: string | number) {
        if (entityId === undefined || entityId === null || entityId === '') {
            return [];
        }

        return pendingExampleWorksStore.get(buildKey(entityType, entityId)) || [];
    },

    setPendingExampleWorks(entityType: PendingEntityType, entityId: string | number, works: PendingExampleWork[]) {
        if (!works.length) {
            pendingExampleWorksStore.delete(buildKey(entityType, entityId));
        } else {
            pendingExampleWorksStore.set(buildKey(entityType, entityId), works);
        }

        emitChange(entityType, entityId);
    },

    clearPendingExampleWorks(entityType: PendingEntityType, entityId?: string | number) {
        if (entityId === undefined || entityId === null || entityId === '') {
            return;
        }

        if (pendingExampleWorksStore.delete(buildKey(entityType, entityId))) {
            emitChange(entityType, entityId);
        }
    }
};
